import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Licenses } from '@shared/constants';
import { License } from '@shared/types';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { LicensesApiService } from 'src/.api-client/services/licenses-api.service';
import { LicensesDto } from '../../.api-client/models/licenses-dto';

@Injectable({ providedIn: 'root' })
export class LicensesService {
    private readonly licensesSubject = new BehaviorSubject<Set<License> | undefined>(undefined);
    public readonly licensesObs = this.licensesSubject.asObservable().pipe(filter(Boolean));

    constructor(private readonly _licensesApiService: LicensesApiService) {
        this._getLicenses().subscribe((licensesDto) => {
            const licenses = new Set<License>(licensesDto.licenses);
            this.licensesSubject.next(licenses);

            //Debug Below
            // const licenses = new Set<License>([
            //     Licenses.Orders,
            //     Licenses.OrderCreation,
            //     Licenses.Reports,
            //     Licenses.PatientsSearch,
            //     Licenses.Documents,
            //     Licenses.Shop,
            //     Licenses.StructMibi,
            //     Licenses.Mibi,
            // ]);
            // this.licensesSubject.next(licenses);
            // console.log('Overwriting licenses for Debugging - new set:', licenses);
        });
    }

    public hasPatientsSearchLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.PatientsSearch);
    }

    public hasOrderCreationLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.OrderCreation);
    }

    public hasOrdersLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.Orders);
    }

    public hasReportsLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.Reports);
    }

    public hasShopLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.Shop);
    }

    public hasDocumentsLicense(): Observable<boolean> {
        return this.hasLicense(Licenses.Documents);
    }

    private hasLicense(license: License): Observable<boolean> {
        return this.licensesObs.pipe(map((licenses) => !!licenses?.has(license)));
    }

    private _getLicenses(): Observable<LicensesDto> {
        return this._licensesApiService.licensesGetLicenses(undefined, new HttpContext());
    }
}
